'use es6';

import PropTypes from 'prop-types';
import { Flex } from 'foundations-components/components/Flex';
import Field from './Field';
import { jsx as _jsx } from "react/jsx-runtime";
const PortField = ({
  baseLangKey,
  fieldName,
  fieldProps,
  isExpanded,
  validationMessages,
  value
}) => /*#__PURE__*/_jsx(Flex, {
  flexShrink: 0,
  margin: 0,
  children: /*#__PURE__*/_jsx(Field, Object.assign({}, fieldProps, {
    "aria-hidden": !isExpanded,
    error: Boolean(validationMessages[fieldName]),
    messageKeySuffix: `${baseLangKey}.portLabel`,
    name: fieldName,
    placeholderKeySuffix: `${baseLangKey}.portPlaceholder`,
    validationMessage: validationMessages[fieldName] ? '' : null,
    type: "number",
    value: `${value.get(fieldName)}`
  }))
});
PortField.propTypes = {
  baseLangKey: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  fieldProps: PropTypes.object.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  validationMessages: PropTypes.object.isRequired,
  value: PropTypes.any.isRequired
};
export default PortField;